import React, { useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Button } from "@heroui/react";

const DownloadZipButton = ({ endpoint, files, fileName, filtrar = true, code = null }) => {
    const [isLoading, setIsLoading] = useState(false); // Estado para mostrar si el botón está ocupado

    const handleDownloadZip = async () => {
        if (!files) return;

        setIsLoading(true); // Iniciar estado de cargando (ocupado)
        const zip = new JSZip();

        // Si "filtrar" es true, filtrar los archivos visibles
        const visibleFiles = filtrar ? files.filter((file) => file.visible) : files;

        try {
            const fileNameMap = {}; // Mapa para rastrear nombres duplicados

            // Obtener los archivos y añadirlos al ZIP
            const filePromises = visibleFiles.map(async (file) => {
                let url = `${endpoint}${file.filename}`;
                if(code){
                    url = `${endpoint}${file.filename}?code=${code}`;
                }
                const response = await fetch(url);
                const blob = await response.blob();

                // Verificar si el nombre contiene el UUID (compuesto por 5 partes separadas por "-")
                let cleanName = file.filename; // Por defecto, usar el nombre completo
                const fileNameParts = file.filename.split('-');

                if (fileNameParts.length > 5) {
                    // Si tiene más de 5 partes separadas por "-", asumimos que tiene un UUID
                    cleanName = fileNameParts.slice(5).join('-'); // Eliminar las primeras 5 partes
                }

                // Manejar nombres duplicados
                let uniqueFileName = cleanName;
                if (fileNameMap[cleanName]) {
                    // Si ya existe, agregar un sufijo único
                    const count = fileNameMap[cleanName] + 1;
                    uniqueFileName = `${cleanName.replace(/\.(\w+)$/, `(${count}).$1`)}`; // example: file(1).txt
                    fileNameMap[cleanName] = count; // Actualizar contador
                } else {
                    // Si no existe, inicializar en el mapa
                    fileNameMap[cleanName] = 1;
                }

                zip.file(uniqueFileName, blob); // Añadir el archivo al ZIP con el nombre único
            });

            // Esperar todas las descargas
            await Promise.all(filePromises);

            // Generar el ZIP y descargarlo
            const zipContent = await zip.generateAsync({ type: "blob" });
            saveAs(zipContent, `${fileName}-adjuntos.zip`);
        } catch (error) {
            console.error("Error al generar el ZIP:", error);
        } finally {
            setIsLoading(false); // Finalizar estado de cargando
        }

    };

    return (
        // <Button
        //     color="primary"
        //     onPress={handleDownloadZip}
        //     isBusy={isLoading} // Si el componente tiene un prop "isBusy", úsalo
        //     disabled={isLoading} // Deshabilitar el botón mientras está ocupado
        // >
        //     {isLoading ? "Procesando..." : "Descargar todos los archivos visibles como ZIP"}
        // </Button>
        <Button
            color="primary"
            onPress={handleDownloadZip}
            isBusy={isLoading} // Si el componente tiene un prop "isBusy", úsalo
            disabled={isLoading} // Deshabilitar el botón mientras está ocupado
        >
            {isLoading ? "Loading..." : "Download all files as ZIP"}
        </Button>
    );
};

export default DownloadZipButton;